<template>
	<widget-card
		colClasses="xs12"
		:heading="widget.text.caption[$i18n.locale]" custom-card-classes="chart-wrapper">
		<div class="d-flex" v-if="widget.data.isSeasonCompare && widget.data.isSeasonCompare === true">
			<v-select
				:items="days"
				v-model="day"
				box
				label="Day1" class="ma-1"></v-select>
			<v-select
				:items="months"
				v-model="month"
				item-text="name"
				value="value"
				box
				label="Month1" class="ma-1"></v-select>
		</div>

		<target-chart class="chart-wrapper" :sets="series" :is-money-value="isMoneyValue" :styles="myStyles"></target-chart>
	</widget-card>
</template>

<script>
	import Enumerable from 'linq'
	import TargetChart from './TargetChart.js'
	import { mapGetters } from 'vuex'
	import moment from 'moment'

	export default {
		props: {
			widget: {
				type: Object,
				required: true
			}
		},
		components: {
			TargetChart
		},
		computed: {
			...mapGetters([
				'season',
				'reportingData',
				'lastSeasonReportingData'
			]),
			myStyles () {
				if (this.widget.data.isSeasonCompare && this.widget.data.isSeasonCompare === true) {
					return {
						height: `80%`,
						position: 'relative'
					}
				} else {
					return {
						height: `95%`,
						position: 'relative'
					}
				}
			},
			series: function () {
				if (this.reportingData.length > 0) {
					if (this.widget.data.sumField) {
						const series = []
						let enumerable = Enumerable.from(this.reportingData)
						
						if (this.widget.data.partners && this.widget.data.partners.length > 0) {
							enumerable = enumerable.where(item =>  this.widget.data.partners.includes(item['wo_partner_name']))
						}

						if (this.widget.data.isSeasonCompare && this.widget.data.isSeasonCompare === true) {
							let enumerableLastSeason = Enumerable.from(this.lastSeasonReportingData)
							const thisYearTargetDate = new Date(moment().year(), this.month - 1, this.day)
							enumerable = enumerable
								.where(x => x.wo_date <= thisYearTargetDate)
								.groupBy(`{Label: $.${this.widget.data.groupBy}, FromDate: $.fromDate}`, null, (key, g) => {
									return {
										label: key.Label,
										fromDate: key.FromDate,
										value: g.sum(`$.${this.widget.data.sumField.field}`),
										color: g.select(item => item.color).first()
									}
								}, '$.Label')
									enumerable = enumerable
							.orderBy('$.fromDate')
							.toArray()

							series.push({
								name: 'This season',
								data: enumerable
							})

							const lastYearTargetDate = new Date(moment().year() - 1, this.month - 1, this.day)
							enumerableLastSeason = enumerableLastSeason
								.where(x => x.wo_date <= lastYearTargetDate)
								.groupBy(`{Label: $.${this.widget.data.groupBy}, FromDate: $.fromDate}`, null, (key, g) => {
									return {
										label: key.Label,
										fromDate: key.FromDate,
										value: g.sum(`$.${this.widget.data.sumField.field}`),
										color: g.select(item => item.color).first()
									}
								}, '$.Label')
								.orderBy('$.fromDate')
								.toArray()

							series.push({
								name: 'Last season',
								data: enumerableLastSeason,
								type: 'line'
							})

							return series
						}
						if (this.widget.data.isSplittingContractual && this.widget.data.isSplittingContractual === true) {
    // Non-contractual und contractual summieren
    let allData = enumerable
        .groupBy(`{Label: $.${this.widget.data.groupBy}, FromDate: $.fromDate}`, null, (key, g) => {
            return {
                label: key.Label,
                fromDate: key.FromDate,
                contractualValue: g.where(item => item['is_contractual'] == true).sum(`$.${this.widget.data.sumField.field}`),
                nonContractualValue: g.where(item => item['is_contractual'] == false).sum(`$.${this.widget.data.sumField.field}`)
            }
        }, '$.Label')
        .orderBy('$.fromDate')
        .toArray();

				let manualIndex = 0;
				let manualIndex1 = 0;
                allData = allData.map(item => {
                    const manualContractualValue = this.contractualValues[manualIndex] || 0; 
                    manualIndex++; 
					const thisYearValues1 = this.thisYearValues[manualIndex1] || 0
					manualIndex1++; 

                    const isEqual = item.nonContractualValue === manualContractualValue;
                    const barColor = isEqual ? 'red' : item.color;
					

                    return {
                        label: item.label,
                        fromDate: item.fromDate,
                        value: thisYearValues1, 
                        contractualValue: manualContractualValue, 
                        color: barColor 
                    };
                });

                series.push({
                    name: 'Total Sales',
                    data: allData.map(item => ({
                        label: item.label,
                        fromDate: item.fromDate,
                        value: item.value, 
                        color: item.color 
                    }))
                });

                series.push({
                    name: 'Target Sales',
                    data: allData.map(item => ({
                        label: item.label,
                        fromDate: item.fromDate,
                        value: item.contractualValue,
                        color: item.color 
                    })),
                    type: 'bar'
                });

                return series;

						} else {
							enumerable = enumerable
								.groupBy(`{Label: $.${this.widget.data.groupBy}, FromDate: $.fromDate}`, null, (key, g) => {
									return {
										label: key.Label,
										fromDate: key.FromDate,
										value: g.sum(`$.${this.widget.data.sumField.field}`),
										color: g.select(item => item.color).first()
									}
								}, '$.Label')
									enumerable = enumerable
							.orderBy('$.fromDate')
							.toArray()

							series.push({
								name: '',
								data: enumerable
							})
							return series
						}
					
					}
					return []
				} else {
					return[]
				}


			},
			isMoneyValue: function () {
				return this.widget.data.sumField ? this.widget.data.sumField.isMoneyValue : false
			},
			days () {
				return [...Array(moment().daysInMonth())].map((_, i) => i + 1)
			},
			months () {
				return moment.months().map((m, i) => ({
					name: m,
					value: i + 1
				}))
				
			},
		},
		watch: {
			'widget.layout.h': {
				handler (val) {
					// this.$refs.chart.render()
				}
			}
		},
		data() {
			return {
				day: moment().date(),
				month: moment().month() + 1,
				contractualValues: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 29, 0, 60, 0, 200, 103, 0, 100, 100, 0, 20, 150, 0],
				thisYearValues: [21, 23, 22, 10, 31, 120, 120, 22, 40, 6, 100, 90, 100, 46, 208, 117, 85, 49, 10, 54, 2, 119, 10, 29, 4, 48, 41, 187, 86, 2, 39, 66, 50, 16, 130, 0]
			}
		},
		methods: {
			
			
		}
	};
</script>

<style>
.chart-wrapper {
  position: relative;
  height: 95%;
  width: 100%;
}
</style>
